
export default function getOppositeDirectionIndex<T>(
  directionList: ReadonlyArray<T>,
  directionIndex: number
): number {
  const index1 = (directionIndex + directionList.length / 2) % directionList.length
  return index1
}